import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { AuthHelpers } from '@eview/core/auth';
import { Permission } from '@eview/core/auth/permission';
import { Post } from '@eview/core/domain/post/post';
import { Form } from '@eview/core/domain/form/form';
import { environment } from '@eview/core';
import { PostHelpers } from '@eview/core/domain/post/post.helpers';
import { AppState } from '@eview/core/store/states/app.state';
import { Store } from '@ngrx/store';
import { selectForms } from '@eview/core/store/selectors/forms.selector';
import { Subscription } from 'rxjs';

const ROLE_PRO_USER: string = 'prouser';

@Component({
  selector: 'eview-post-actions',
  templateUrl: 'post-actions.component.html',
  styleUrls: ['post-actions.component.scss']
})
export class PostActionsComponent implements OnInit, OnChanges, OnDestroy {
  @Input() public post: Post;
  @Input() private activities;
  @Input() private users;
  @Input() public showHistory: Boolean;
  @Input() public showDelete: Boolean;
  @Input() public showEdit: Boolean;
  @Output() public onRefreshClick: EventEmitter<any> = new EventEmitter();
  @Output() public onEditClick: EventEmitter<any> = new EventEmitter();
  @Output() public onClose: EventEmitter<any> = new EventEmitter();
  @Output() public onDelete: EventEmitter<any> = new EventEmitter();

  format: string = environment.format.date;
  PostHelpers = PostHelpers;
  formsCatalog: Form[] = [];
  private formsSub!: Subscription;

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.formsSub = this.store.select(selectForms).subscribe(forms => {
      this.formsCatalog = forms?.results ? [...forms.results] : [];
    });
  }

  ngOnChanges() {
  }

  ngOnDestroy() {
    this.formsSub?.unsubscribe();
  }

  getContact(item, users) {
    const value = JSON.parse(item.value);
    let data = {};
    users.forEach(user => {
      if (user.id === value.updated_by) {
        data = user;
      }
    });
    if (data['contacts'] !== undefined && data['contacts'].length > 0) {
      return data['contacts'][0]['contact'];
    } else {
      return '';
    }
  }

  getTypes(item) {
    if (item.type === 'create') {
      return 'created';
    } else {
      return 'updated';
    }
  }

  getPostName(val) {
    const postDetail = JSON.parse(val);
    return (postDetail && postDetail.title !== '') ? '"' + postDetail.title + '"' : '';
  }



}
